import { render, staticRenderFns } from "./workShopReview.vue?vue&type=template&id=986dd382"
import script from "./workShopReview.vue?vue&type=script&lang=js"
export * from "./workShopReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports